module.exports = __webpack_public_path__ + "assets/img/config-table-8b55948b.png";